/**
 * Speak lesson text with a German system voice.
 */

let germanVoice = null;

const pickGermanVoice = () => {
  if (typeof window === "undefined" || !window.speechSynthesis) return null;
  const voices = window.speechSynthesis.getVoices() || [];
  return (
    voices.find((v) => /^de-DE/i.test(v.lang) && /anna|helena|hedda|katja|petra|female/i.test(v.name)) ||
    voices.find((v) => /^de-DE/i.test(v.lang)) ||
    voices.find((v) => /^de/i.test(v.lang)) ||
    null
  );
};

const ensureVoice = () => {
  if (typeof window === "undefined" || !window.speechSynthesis) return;
  germanVoice = pickGermanVoice();
  if (!germanVoice) {
    window.speechSynthesis.onvoiceschanged = () => {
      germanVoice = pickGermanVoice();
    };
  }
};

ensureVoice();

export const canSpeakEnglish = () =>
  typeof window !== "undefined" && Boolean(window.speechSynthesis);

export const speakEnglish = (text) => {
  if (!text || !canSpeakEnglish()) return false;
  try {
    ensureVoice();
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(String(text));
    utterance.lang = germanVoice?.lang || "de-DE";
    if (germanVoice) utterance.voice = germanVoice;
    utterance.rate = 0.98;
    utterance.pitch = 1.08;
    window.speechSynthesis.speak(utterance);
    return true;
  } catch {
    return false;
  }
};

export const stopSpeakingEnglish = () => {
  if (!canSpeakEnglish()) return;
  try {
    window.speechSynthesis.cancel();
  } catch {
    // ignore
  }
};
